<template>
  <span class="Time">
    {{ hour }}<span v-if="hourSuffix" class="Time-suffix">{{ hourSuffix }}</span>
  </span>
</template>

<script setup lang="ts">
import { useI18nMeta } from '@cvo/i18n/composables/useI18nMeta';
import { format } from 'date-fns';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  date: Date;
  timeFormat?: string;
}>(), {
  timeFormat: 'HH:mm',
});

const { is24HourCycle } = useI18nMeta();

const timeFormatWithHourCycle = computed(() => {
  return is24HourCycle.value ? props.timeFormat : props.timeFormat.replaceAll('H', 'h');
});

const hour = computed<string>(() => {
  return format(props.date, timeFormatWithHourCycle.value);
});

const hourSuffix = computed<string>(() => {
  return is24HourCycle.value ? '' : format(props.date, 'aa');
});
</script>

<style lang="scss">
@layer cvo-ui {
  .Time {
    &-suffix {
      font-size: 0.625em;
      text-transform: uppercase;
      margin-inline-start: 0.3em;
    }
  }
}
</style>